module.exports = __webpack_public_path__ + "static/img/bgSolution.bec229c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgSolution.jpg
// module id = 9hrV
// module chunks = 13